import React, { useEffect, useState } from 'react';
import { Upload } from 'antd';
import { FiEdit } from 'react-icons/fi';

function UploadImage(props) {
  const { logoImage, handleChangeLogo } = props;
  const [previewImage, setPreviewImage] = useState('');

  const uploadButton = (
    <div>
      <div className="btn btn-red">Upload</div>
    </div>
  );
  useEffect(() => {
    if (logoImage[0]?.hasOwnProperty('fileId')) {
      setPreviewImage(logoImage[0].url);
    }
    if (logoImage[0]?.hasOwnProperty('originFileObj')) {
      const reader = new FileReader();
      reader.readAsDataURL(logoImage[0]?.originFileObj);
      reader.onload = (e) => {
        setPreviewImage(e.target.result);
      };
    }
  }, [logoImage]);

  return (
    <Upload
      maxCount={1}
      listType="picture"
      fileList={logoImage}
      accept="image/*"
      showUploadList={false}
      onChange={handleChangeLogo}
      beforeUpload={() => false}
    >
      <div className="edit-profile-pic-icon">
        {previewImage ? <FiEdit className="icon-position" /> : ''}
      </div>
      <div title="Edit Logo">
        {previewImage ? (<img src={previewImage} alt="avatar" style={{ width: '100px' }} />) : (uploadButton)}
      </div>
    </Upload>
  );
}
export default UploadImage;
